<mat-form-field>
  <input matInput [type]="hidePassword ? 'password' : 'text'" [id]="inputId" required ngDefaultControl [formControl]="control" />
  <button
    type="button"
    mat-icon-button
    matSuffix
    (click)="togglePasswordVisibility()"
    [attr.aria-label]="hidePassword ? ('LABEL.SHOW_PASSWORD' | translate) : ('LABEL.HIDE_PASSWORD' | translate)"
    [attr.aria-pressed]="hidePassword"
  >
    <app-icon [name]="hidePassword ? 'eye-off' : 'eye'"></app-icon>
  </button>
</mat-form-field>
